<template>
    <div class="form-ctrl" :class="{small:small,large:large, fullwidth:fullWidth}">
        <small v-if="label || mobilelabel">
            <span :class="{normal:mobilelabel}" v-if="label">
                {{label}}: {{required?"*":""}}
            </span>
            <span class="mobile" v-if="mobilelabel">{{mobilelabel}}: {{required?"*":""}}</span>
        </small>
        <input
                type="text"
                v-on:input="$emit('input', $event.target.value)"
                :value="value"
                :required="required"
                :id="id"
                @blur="$emit('leave')"
                :class="{fullwidth:fullWidth}"
                :maxlength="max"
                :placeholder="placeholder"
                :disabled="disabled"
        />


        <div class="invalid" v-if="error">
            {{errorMessage}}
        </div>
    </div>
</template>

<script>

    export default {

        props: {
            disabled:{
                type:Boolean
            },

            id: {
                type: String
            },
            value: {
                type: String
            },
            label: {
                type: String
            },
            mobilelabel:{
                type: String
            },
            required: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            error:{
                type:Boolean,
                default:false
            },
            errorMessage:{
                type:String
            },
            fullWidth:{
                type:Boolean,
                default:false

            },
            max:{
                type:Number,
                default:200
            },
            placeholder:{
                type:String,
                default:""

            }
        }
    }
</script>

<style lang="scss" scoped>
    .small {
        width: 60% !important;

    }
    small{
        white-space: nowrap;
        .normal{
            display: block;
            @media screen and (max-width: 800px){
                display: none;
            }
        }
        .mobile{
            display: none;
            @media screen and (max-width: 800px){
                display: block;
            }
        }
    }
    .fullwidth{
        @media screen and(max-width: 800px) {
            width: 100%;
            margin-left:0px !important;

        }
    }
    .form-ctrl {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-left: 10px;

        small {
            color: grey;
        }

        input[type="text"], select {
            background-image: none;
            background-color: transparent;
            box-shadow: none;
            border-radius: 6px;
            border: 1px solid #231F20;
            padding: 7px;
            width: 100%;
            @media screen and(max-width: 800px) {
                margin-bottom: 5px;
            }
        }

    }

    .form-ctrl:first-child {
        margin-left: 0 !important;
    }


    .invalid {
        color: red;
        font-size: 12px;
        margin-top: 3px;
    }
</style>
